import styled from "styled-components";
import { black, blue, hoverBlue } from "../../assets/ui/colors";
import { Dialog } from "@material-ui/core";
import { FormValidate, InputContainer } from "../Auth/Auth.style";

export const StyledDialog = styled(Dialog)`
  & .MuiPaper-root {
    padding: 40px 40px;
  }
  @media (max-width: 600px) {
    margin-right: 12px;
    .MuiDialog-container {
      width: 100vw;
    }
    .MuiPaper-root {
      padding: 10px 10px;
      margin: auto 10px;
    }
  }
`;

export const StyledDialogTitle = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: start;
  padding: 0;
`;

export const StyledDialogContent = styled.div`
  padding: 0 72px;
  @media (max-width: 600px) {
    padding: 0 10px;
  }
`;

export const StyledHeader = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  letter-spacing: 0.1px;
  color: ${blue};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 42px 24px 0 72px;
  @media (max-width: 600px) {
    margin: 42px 0 0 10px;
  }
`;

export const StyledSubHeader = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 1.25px;
  text-transform: uppercase;
  margin-top: 14px;
  color: ${black};
`;

export const StyledFormValidate = styled(FormValidate)`
  padding: 0;
  margin: 0;
`;

export const StyledInputContainer = styled(InputContainer)`
  margin-top: 28px;
  & .MuiInputBase-inputMultiline {
    height: 112px;
    overflow: auto;
    padding: 16px 12px;
  }
`;

export const StyledButtonsRow = styled.div`
  display: flex;
  padding: 0 66px 40px 66px;
  & .MuiButtonBase-root {
    margin: 0 6px;
  }
  & .MuiButton-contained {
    background-color: ${hoverBlue};
    color: white;
    :hover {
      background-color: ${blue};
    }
  }
  @media (max-width: 600px) {
    padding: 0 10px 40px 10px;
  }
`;
